import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form', 'results', 'loadingSpinner', 'fieldInput', 'img'];

  // static values = {
  //   count: Number,
  // };

  connect() {
    // Todo: Add LoadMore
    this.formTarget.addEventListener('submit', (event) => {
      event.preventDefault();
    });
    this.formData = new FormData(this.formTarget);

    this.ajaxUrlLang = document.documentElement.lang == 'en-US' ? '/en' : '';

    this.ajaxUrl = '/ajax/location-filter';

    this.debounceTimeout = null;
    this.isLoading = false;

    this.queryString = this.buildQueryString();
  }

  async applyFilter() {
    this.updateFormData();
    this.clearResultsContainer();
    this.showLoadingSpinner();
    const data = await this.fetchResults();
    this.updateUrl();
    this.populateResultsContainer(data);
    this.hideLoadingSpinner();
    this.updateImage();
  }

  async fetchResults() {
    try {
      this.queryString = this.buildQueryString();

      const response = await fetch(`${this.ajaxUrlLang}${this.ajaxUrl}?${this.queryString}`);

      if (!response.ok) {
        throw new Error(`Failed to fetch: ${response.statusText}`);
      }

      const data = response.text();

      return data;
    } catch (error) {
      console.error('Error fetching results:', error);
    }
  }

  buildQueryString() {
    const params = new URLSearchParams();
    for (const [key, value] of this.formData.entries()) {
      if (params.has(key)) {
        params.append(key, value);
      } else {
        params.set(key, value);
      }
    }
    return params.toString();
  }

  populateResultsContainer(html) {
    this.resultsTarget.insertAdjacentHTML('beforeend', html);
  }

  clearResultsContainer() {
    this.resultsTarget.innerHTML = ''; // Clear all existing results
  }

  updateUrl() {
    if (this.queryString == '') {
      const url = new URL(window.location.href);
      // Remove all parameters
      url.search = '';
      // Update the browser's URL without reloading
      window.history.replaceState(null, '', url);
    } else {
      // Update the URL with the new query string using history.pushState
      const newUrl = `${window.location.pathname}?${this.queryString}`;
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
  }

  showLoadingSpinner() {
    if (this.hasLoadingSpinnerTarget) {
      this.loadingSpinnerTarget.style.display = 'block';
    }
  }

  hideLoadingSpinner() {
    if (this.hasLoadingSpinnerTarget) {
      this.loadingSpinnerTarget.style.display = 'none';
    }
  }

  updateFormData() {
    this.formData = new FormData(this.formTarget);
  }

  updateImage() {
    if (this.hasImgTarget) {
      this.imgTargets.forEach((img) => {
        img.classList.add('opacity-0');
        if (img.dataset.id == this.formData.get('location')) {
          img.classList.remove('opacity-0');
        }
      });
    }
  }
}
